/*****
 * ====================================================================================
 * Project: noloPathInsert jQuery Plugin
 * Description: provides support of various analytics for noloPath pages
 * Author: Ian Cruz @ Nolo
 * Version: 1.0.0
 * jQuery Version: 2.1.3
 * ====================================================================================
 */




// noloPathInsert JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloPathInsert PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var noloPathInsert = function (element, options) {
        this.$element = $(element);
        this.options  = $.extend(true, {}, noloPathInsert.DEFAULTS, this.getDataAttributeOptions(), options);
        this.query       = this.getQueryParams();

        // Initialize the plugin
        this.init();
    }




    // noloPathInsert PLUGIN NAME
    // ================================================================================
    noloPathInsert.NAME  = 'noloPathInsert';
    noloPathInsert.DATANAME = 'nolo.' + noloPathInsert.NAME;




    // noloPathInsert VERSION
    // ================================================================================
    noloPathInsert.VERSION  = '1.0.0';




    // noloPathInsert CONSTANTS
    // ================================================================================
    noloPathInsert.CONSTANTS = {
        'serviceUrl'              : '/path2/',
        'defaultBlockId'          : 'none',
        'defaultRegionId'         : 'none',
        'defaultInsertMethod'     : 'append',
        'defaultRelocationMethod' : 'before',
        'allowedInsertionMethods' : ['append', 'prepend', 'after', 'before', 'html'],
    }




    // noloPathInsert DEFAULT OPTIONS
    // ================================================================================
    noloPathInsert.DEFAULTS = {
        'layoutId'     : 'cNPHLayoutDefaultBare',
        'path'         : 'min-path7',
        'pid'          : 1,
        'surl'         : null,
        'domain'       : null,
        // 'routing'      : null,
        'insertMethod' : noloPathInsert.CONSTANTS.defaultInsertMethod,
        'target'       : null,
        'depth'        : 0,
        'region_id'    : noloPathInsert.CONSTANTS.defaultRegionId,
        'block_id'     : noloPathInsert.CONSTANTS.defaultBlockId,
        'path_url'     : null,
        'source'       : null,
        'sourceData'   : null,
    }




    // noloPathInsert PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    noloPathInsert.prototype.init = function(){
        // load the target path into the page
        this.loadPath();
    }

    noloPathInsert.prototype.getDataAttributeOptions = function(){
        var options = this.$element.data();
        return options;
    }

    noloPathInsert.prototype.getElement = function(selector){
        var $elm = this.$element;

        return (typeof selector === 'string') ? $elm.find(selector) : $elm;
    }

    noloPathInsert.prototype.getQueryParams = function(myQuery){
        var params = {};
        var query = (typeof myQuery === 'string') ? '?' + myQuery : location.search;
        var q, a, b;
        if(query.length > 0){
            q = query.substr(1, query.length-1);
            a = q.split('&');
            for (var i=0; i<a.length; i++){
                b = a[i].split('=');
                params[b[0]]=b[1];
            }
        }
        return params;
    }

    noloPathInsert.prototype.getOptions = function(key){
        var options = this.options;

        return (typeof key !== 'undefined') ? options[key] : options;
    }

    noloPathInsert.prototype.getTarget = function() {
        var target = this.getOptions('target');
        var depth  = this.getOptions('depth');
        var hasTarget = this.isValidTarget(target);
        var hasDepth = this.isValidDepth(depth);
        var $target;

        // check if a new target element for the path exists
        if (hasTarget) {
            // get the nth-child, if valid depth is provided
            // -----
            // @note:
            // + depth has to be a positive integer value
            if(hasDepth) {
                target = target + ' > :nth-child(' + depth + ')';
            }

            $target = $(target);

            // use only the first match, in-case $target matches multiple selectors
            return $target.eq(0);
        }

        return;
    }

    noloPathInsert.prototype.getInsertMethod = function() {
        var insertMethod = this.getOptions('insertMethod') || noloPathInsert.CONSTANTS.defaultInsertMethod;
        var allowed = noloPathInsert.CONSTANTS.allowedInsertionMethods;
        var target = this.getOptions('target');
        var depth = this.getOptions('depth');
        var hasTarget = this.isValidTarget(target);
        var hasDepth = this.isValidDepth(depth);

        if (allowed.indexOf(insertMethod) === -1) {
            throw "Insert method " + insertMethod + " is not supported please use one of the following: " + allowed.join(',');
        } else {
            // override insert method
            // -----
            // @note:
            // + if we have a depth and a target, we want to use 'before',
            //   so we can reliably use jQuery nth-child()
            // + depth has to be a positive integer value
            if(hasTarget && hasDepth) {
                insertMethod = noloPathInsert.CONSTANTS.defaultRelocationMethod;
            }

            return insertMethod;
        }
    }

    noloPathInsert.prototype.getBlockId = function(){
        var $elm = this.getElement();

        // Retrieve the block id
        // -----
        // @note:
        // + retrieving the id will only be applicable for Drupal content using any of the 'hubv6' themes
        // + the block id to retrieve will be stored in the attribute 'id' within the 'block.tpl.php' or 'block-text_block.tpl.php' file
        var $parent = $elm.parents('.block');
        var block_id = $parent.attr('id');

        // Return the block id or the configured default
        return block_id || noloPathInsert.CONSTANTS.defaultBlockId;
    }

    noloPathInsert.prototype.getRegionId = function(){
        var $elm = this.getElement();

        // Retrieve the region id
        // -----
        // @note:
        // + retrieving the id will only be applicable for Drupal content using any of the 'hubv6' themes
        // + the region id to retrieve will be stored in the attribute 'data-region-id' within the 'region.tpl.php' file
        // + limit to the most immediate parent with 'eq(0)'
        var $parent_region = $elm.parents('.region').eq(0);
        var region_id = $parent_region.data('regionId');

        // Retrieve relocation target
        var $target = this.getTarget();

        // Determine new region id based on relocation target
        if ($target && $target.length > 0){
            // Determine new parent region
            // -----
            // @note:
            // + relocation may use a $target that would get multiple hits for '.region'
            // + limit to the most immediate parent with 'eq(0)'
            $parent_region = $target.parents('.region').eq(0);

            // Determine new region id
            // -----
            // @note:
            // + relocation may use a $target that would get multiple hits for '.region'
            region_id = $parent_region.data('regionId');
        }

        // fallback identification to the 'id' attribute if present
        // -----
        // @note:
        // + NCMS will primarily identify the region this way
        if (typeof region_id === 'undefined'){
            region_id = $parent_region.attr('id') || noloPathInsert.CONSTANTS.defaultRegionId;

            // Clean the id
            // -----
            // @note
            // + the id attribute will return a value in the format 'region-[regionId]' where:
            //   + [regionId]: the region name where the underscores are replaced by hyphens
            // + revert the 'id' back to the original
            region_id = region_id.replace(/-/g, '_');
            region_id = region_id.replace(/region_/g, '');
        }

        // Return the region id or the configured default
        return region_id || noloPathInsert.CONSTANTS.defaultRegionId;
    }

    noloPathInsert.prototype.getRouting = function(){
        var routing = this.getOptions('routing');
        var route = {'sendRouting': false, 'routing': routing};

        // test if routing is a string list, or an array in the form of a string
        if(typeof routing === 'string'){
            if(routing.indexOf(',') > -1){
                // strip the brackets and straight quotes, if found
                routing = routing.replace(/[\[\]']/g, '');

                // strip spaces after any commas
                routing = routing.replace(/,( +)/g, ',');

                // convert into a proper array
                routing = routing.split(',');
            }

            // update routing
            route.sendRouting = true;
            route.routing = routing;
        } else if(typeof routing === 'boolean') {
            // update routing
            route.sendRouting = true;
            route.routing = routing;
        }

        return route;
    }

    noloPathInsert.prototype.getPathUrl = function(){
        var serviceUrl = this.getOptions('serviceUrl') || noloPathInsert.CONSTANTS.serviceUrl;
        if (window.location.href.includes('lawyers.nolo.com') || window.location.href.includes('lawyers-nolo-com')) {
            serviceUrl = 'https://www.nolo.com' + serviceUrl;
        }
        var path_url = serviceUrl + this.getOptions('path');
        return path_url;
    }

    noloPathInsert.prototype.getLoadPathData = function() {
        var $elm = this.getElement();
        var data = {
            'layoutId'   : this.getOptions('layoutId'),
            'pid'        : this.getOptions('pid'),
            'surl'       : this.getOptions('surl'),
            'serviceUrl' : this.getOptions('serviceUrl'),
            'pathLoader' : noloPathInsert.NAME,
            'region_id'  : this.getRegionId(),
            'block_id'   : this.getBlockId(),
            'path_url'   : this.getPathUrl(),
            'query_params' : this.getQueryParams(),
        };

        var routing = this.getRouting();
        var elementId = $elm.attr('id');
        var domain = this.getOptions('domain');
        var source = this.query.source || this.getOptions('source');
        var sourceData = this.query.data || this.getOptions('sourceData');
        var questionnaire = this.getOptions('questionnaire');

        // add routing parameter, if available
        if(routing.sendRouting){
            data.routing = routing.routing;
        }

        // add insert element id, if available
        if(elementId){
            data.insertElementId = elementId;
        }

        // add domain parameter, if available
        if(domain){
            data.domain = domain;
        }

        // add source parameter, if available
        if(source){
            data.source = source;
        }

        // add sourceData parameter, if available
        if(sourceData){
            data.data = sourceData;
        }

        if(questionnaire) {
            data.questionnaire = questionnaire;
        }

        return data;
    }

    noloPathInsert.prototype.isNumeric = function(num, testInteger){
        var x = isNaN(num) ? false : Number(num);
        var isNumeric = (typeof x === 'number');

        if (typeof testInteger === 'boolean' && testInteger){
            return isNumeric && (x % 1 === 0);
        }

        return isNumeric;
    }

    noloPathInsert.prototype.isInteger = function(num){
        return this.isNumeric(num, true);
    }

    noloPathInsert.prototype.isValidDepth = function(d){
        var depth = (typeof d !== 'undefined') ? d : this.getOptions('depth');

        // depth has to be a positive integer value
        return (this.isInteger(depth) && (depth > 0));
    }

    noloPathInsert.prototype.isValidTarget = function(t){
        var target = (typeof t !== 'undefined') ? t : this.getOptions('target');

        // target has to exist
        return ((typeof target === 'string') && ($(target).length > 0));
    }

    noloPathInsert.prototype.loadPath = function(){

        var data = this.getLoadPathData();
        var url=this.getPathUrl();
        var onLoadSuccess = $.proxy(this, 'onLoadSuccess');
        var onLoadError = $.proxy(this, 'onLoadError');

        // create the promise
        var promise = $.ajax({
            type: 'POST',
            crossDomain: true,
            url: url,
            data: data,
            dataType: 'html',
        });

        // on success, load the path
        promise.done(onLoadSuccess);

        // catch ajax errors
        promise.fail(onLoadError);
    }

    noloPathInsert.prototype.onLoadSuccess = function(data, status, xhr){
        var $elm = this.getElement();
        var insertMethod = this.getInsertMethod();
        var $target = this.getTarget();

        // insert the results depending on target element
        if($target){
            // relocate the element into the target, using the defined insert method
            $target[insertMethod]($elm);

            // add 'relocated' class
            $elm.addClass('relocated');

            // append the results into the element
            $elm.append(data);
        } else {
            // no target specified
            // insert the results using the defined insert method
            $elm[insertMethod](data);

        }
        if($.inArray($("#nolopath-insert").attr('data-pid'), ["1", "30", "83", "128", "125", "133"]) !== -1) {
            //this is an injury AOP
        } else {
            $("[data-label-last='Submit']").text('Connect with Local Attorneys');
            $("[data-label-last='Submit']").attr('data-label-step', 'Connect with Local Attorneys');
            if (document.querySelector('body').classList.contains('theme-quasar')) {
                $("[data-label-last='Submit']").css({"font-size":"1.6rem"});
            }
            if(window.location.hostname.includes('legal-info') && window.location.hostname.includes('lawyers.com') || (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {
                document.querySelector('#nolopath-insert .form-title span.ex').style="display:none";
            }
        }
    }

    noloPathInsert.prototype.onLoadError = function(xhr, status, error){
        // catch based on xhr.readyState
        // ----------
        // xhr.readyState valid values:
        // + 0: request not initialized
        // + 1: server connection established
        // + 2: request received
        // + 3: processing request
        // + 4: request finished and response is ready
        // ----------
        // @note:
        // + it is possible that this will be triggered when it is about to make a request,
        //   but interupted by leaving the page prematurely
        // + just catch it, but do not file an obvious error for the user
        if(xhr.readyState === 0){
            return false;
        }

        return false;
    }




    // noloPathInsert PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(noloPathInsert.DATANAME);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(noloPathInsert.DATANAME, (data = new noloPathInsert(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[noloPathInsert.NAME];

    // assign the noloPathInsert PLUGIN DEFINITION
    $.fn[noloPathInsert.NAME]                = Plugin;

    // assign the noloPathInsert PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[noloPathInsert.NAME]['constructor'] = noloPathInsert;




    // noloPathInsert NO CONFLICT
    // ================================================================================
    $.fn[noloPathInsert.NAME]['noConflict'] = function () {
        $.fn[noloPathInsert.NAME] = old;
        return this;
    }




    // noloPathInsert DATA-API
    // ================================================================================
    $(document).ready(function(){
        // auto-initialize elements that contain the 'data-toggle="noloPathInsert"' attribute
        var $elm = $('[data-toggle^="noloPathInsert"]');

        // pass a blank object to simplify the initialization
        // default plugin options and data attribute configuration options will be used for data-api initialization
        var option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });
}(jQuery, window, document);

